import { ChatBrowserMessage } from "@/domains/chat/constants/chat";

export default function getPlayerTitleContent(message: ChatBrowserMessage): string | null {
  if (message.message.player.title === null) {
    return null;
  }

  const segments = [];
  segments.push(message.message.player.title.name);
  segments.push(`[${message.message.player.title.id}]`);
  segments.push(" ");

  return segments.filter((v: string | null) => v !== null && v.length).join(" ");
}
